import { Instance, types } from 'mobx-state-tree';
import { OwnAssistanceItemModel } from './OwnAssistanceItemModel';

export const CompanyRegionModel = types.model('CompanyRegionModel', {
  region: types.string,
  language: types.string,
});

export type ICompanyRegionModel = Instance<typeof CompanyRegionModel>;


export const CompanyModel = types.model('CompanyModel', {
  _id: types.identifier,
  hasAccessToEvolunoAssistance: types.boolean,
  hasAccessToOwnAssistance: types.boolean,
  hasAccessToScheduler: types.maybeNull(types.boolean),
  hasAccessToFaceScan: types.maybeNull(types.boolean),
  hasAccessToWpoAssistance: types.boolean,
  withRedoSession: types.maybeNull(types.boolean),
  logo: types.maybeNull(types.string),
  assistanceInfo: types.maybeNull(types.string),
  pricingQuestion: types.maybeNull(types.string),
  explanationConditioning: types.maybeNull(types.string),
  ownAssistanceText: types.maybeNull(types.string),
  ownAssistanceTitle: types.maybeNull(types.string),
  ownAssistanceButtonText: types.maybeNull(types.string),
  ownAssistanceColor: types.maybeNull(types.string),
  ownAssistanceItems: types.maybeNull(types.array(OwnAssistanceItemModel)),
  companyRegions: types.maybeNull(types.array(CompanyRegionModel)),
  defaultRegion: types.optional(CompanyRegionModel, {
    region: 'BE',
    language: 'fr',
  })
});

